import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5jrcwz8fv: FaireProductEntity = {
  token: "p_w5jrcwz8fv",
  type: "product",
  name: "GARLIC CHILI CRISP – THE BIG ONE (16OZ.)",
  brandToken: "b_efvu4d6w47",
  brandName: "KariKari",
  imageUrl:
    "https://cdn.faire.com/fastly/782360afb02dc47f3528ed528d8baf67decaa650fa5f17c4c453b04cba3fa6ef.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/789c3caa430473d2842b68648a0f12f41fa626488c8af66eaeaf7f8a162394c1.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Crunchy. Spicy. Garlicky. Magic.\n\n A 16oz. jar of our original Garlic Chili Crisp! More spicy, garlicky, magic to love, more flavor to share!\n\nMeet your new obsession: KariKari Garlic Chili Crisp. Overflowing with golden garlic, crispy shallots, and crunchy peanuts in rich chili oil, it’s bold, complex, and delivers a craveable crunch that transforms anything it touches.\n\nIf you reach for olive oil for richness and hot sauce for heat, reach for KariKari when you want crunch, umami, and bold flavor — plus savory depth and that addictive “what is this and why is it so good?” factor. Handcrafted in small batches, it’s made for flavor lovers who want more out of every bite.\n\nThis isn’t just another condiment or sauce — it’s your kitchen’s MVP. The champion for all your snacks. Drizzle it over eggs, meats, seafood, noodles, sandwiches, pizza, rice bowls, tinned fish, roasted veg, tinned fish, and even vanilla ice cream! Once you open a jar, there’s no going back.\n\nSpoon it. Drizzle it. Share it. Just don’t be surprised when you’re hooked.\n\n\n\n",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:31.285Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
